<template>
    <div class="md:w-[640px] min-h-screen  pb-40 w-full  ">
        <!-- <div class="mb-4 font-bold text-lg justify-between flex flex-col ">
            <h1 class="pl-2">칼럼/뉴스</h1>    
        </div> -->
        <iframe
            id="imported-content"
            :src="postUrl"
            width="100%"
            height="100%"
            frameborder="0"
            style="height: 100vh;"
        ></iframe>
    </div>

</template>
  
<script lang="ts" setup>
import { ref, computed, watch } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';

const store = useStore();
const route = useRoute();

const postUrl = computed(() => store.state.columnNewsUrl);

// 모든 채널 데이터에 대한 computed 속성
const allData = computed(() => store.getters.allChannelData);

// 선택된 게시물에 대한 computed 속성
const selectedPost = computed(() => {
    const index = Number(route.params.id); // route.params.id를 숫자로 변환
    return allData.value.find(data => data.id === index);
});

// selectedPost의 변경사항을 감시하고, 해당 게시물의 htmlLink1 값을 SET_COLUMN_URL 커밋으로 저장
watch(selectedPost, (newVal) => {
    if (newVal && newVal.htmlLink1) {
        store.commit('SET_COLUMN_URL', newVal.htmlLink1);
    }
}, { immediate: true }); // immediate: true 옵션으로 컴포넌트 마운트 시 즉시 실행



</script>
<style>
</style>
<!-- onMounted(async () => {
    if(setHtmlUrl() === 'fail'){
        router.push('/not-found')
        return;
    }
    store.commit('SET_COLUMN_URL', setHtmlUrl()) // /news, /0 , html링크
    const rsp = await axios.get(postUrl.value);
    callResult.value = rsp.data;

    //  HTMLIFrameElement로 타입 캐스팅
    const iframe = document.getElementById('imported-content') as HTMLIFrameElement;
    if (iframe.contentWindow) {
        iframe.contentWindow.document.open();
        iframe.contentWindow.document.write(callResult.value);
        iframe.contentWindow.document.close();
    }
});
const setHtmlUrl = () => {
    let url;
    let index = route.params.id as unknown as number

    if (route.path.includes('/column/news')) {
        if (index >= 0 && index < columnData.length) {
            url = columnData[index].html;
        } else {
            return 'fail';
        }
    } 
    else {
        if (index >= 0 && index < associationData.length) {
            url = associationData[index].html;
        } else {
            return 'fail';
        }
    } 
    return url; // 최종 URL 반환
}; -->